export default "__VITE_ASSET__BwoAON9N__"